module.exports = __webpack_public_path__ + "static/fonts/SourceHanSansCN-Regular.11c302dd.otf";